import { PriceFeedProvider } from './../../providers/price-feed/price-feed';
import { ViewController, NavController } from 'ionic-angular';
import { Exchange } from './../../models/Exchanges';
import { Component, Input } from '@angular/core';

/**
 * Generated class for the ExchangeComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'exchange',
  templateUrl: 'exchange.html'
})
export class ExchangeComponent {

  exchange: Exchange;
  selectedQuote: string;
  pairs: string[];
  constructor(public viewCtrl: ViewController, public priceFeed: PriceFeedProvider) {
    this.exchange = viewCtrl.getNavParams().get('exchange');

  }

  dismiss(){
    this.viewCtrl.dismiss();
  }

  selectQuote(quote: string){
    if(this.selectedQuote == quote){
      this.selectedQuote = null;
      this.pairs = [];
    }else{
      this.selectedQuote = quote;
      this.pairs = [this.exchange.getPairsForQuote(quote)[0]];
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/exchange/exchange.ts